import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';
import  {deleteData } from '../ApiCalls/DataApis';
import {fetchOrganizations, fetchSelectedOrganization} from '../store/actions/organizationActions';


const styles = theme => ({
  paper: {
    position: 'relative',
    width: theme.spacing(60),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]:{
      width: theme.spacing(43),
    }
  },
  button: {
    width: '100%',
    height: '100%',
    fontSize:'12px',
    border:'0px solid #4f86ce',
    justifyContent: 'flex-start',
    fontFamily:'Trebuchet MS',
    '&:hover': {
      backgroundColor:'transparent',
    },
    '&:active': {
      position:'relative',
      top:'1px',
      color:'#fafafa',
      
    },
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fafafa',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  dialog: { borderRadius: 10 } ,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class DeleteOrganizationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open,
      loading: false,
      success: false,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.submitButtonClick = this.submitButtonClick.bind(this);
  }


  handleOpen = () => {
    this.setState({ 
      open: true,
      loading: false,
      success: false,
     });
  };

  handleClose = () => {
    this.setState({ 
      open: false,
      loading: false,
      success: false,
     });
  };

  componentWillReceiveProps({open}) {
    this.setState({...this.state,open})
  }

  submitButtonClick = () => {
    const { loading } = this.state;
    if (!loading) {
      this.setState(
        {
          success: false,
          loading: true,
        },
        () => {
        // deleteData('https://api.iotflows.com/v1/organizations/' + this.props.selectedOrganization.organization_uuid)
        deleteData('https://api.iotflows.com/v1/organizations/' + this.props.organizationInfo.organization_uuid)
          .then(async response => {
            if(response.ok){
              this.setState({
                success: true,
                loading: false,
              });
              this.props.showSuccessSnackbar("Organization has been successfully deleted!");
              this.setState({
                loading: false,
                success: false,
                open:false,
              },() => { 
                this.handleClose();
                this.props.fetchOrganizations();
                this.props.handleCloseModal(); 
              });
            }
            else{
              try{
                const data = await response.json();
                this.props.showErrorSnackbar(data.message);
                this.setState({
                  loading: false,
                  success: false,
                  open:false,
                });
              }catch (e){
                this.props.showErrorSnackbar('Something went wrong');
              }
            }
          })
        }
      )
    }
  };

  

  render() {
    const { classes, selectedOrganization } = this.props;
    const { open, loading, success } = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });
    

    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        direction="column"
        
      >
        {/* <Button className={classes.button} variant="outlined"  onClick={this.handleOpen}>Delete Organization</Button> */}
          
          <Dialog
              open={open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              keepMounted
              classes = {{paper: classes.dialog}}
            >
              <Paper className={classes.paper} >
                {/* <DialogTitle style={{paddingBottom: '0px'}} id="alert-dialog-slide-title">Delete {this.props.selectedOrganization.organization_name} organization</DialogTitle> */}
                <DialogTitle style={{paddingBottom: '0px'}} id="alert-dialog-slide-title">Delete {this.props.organizationInfo.organization_name} organization</DialogTitle>
                <DialogContent dividers style={{paddingBottom: '20px', paddingTop: '20px'}}>
                
                  <DialogContentText style={{margin: '0px'}} id="alert-dialog-description">
                    {/* Are you sure you want to delete {this.props.selectedOrganization.organization_name} organization? */}
                    Are you sure you want to delete {this.props.organizationInfo.organization_name} organization?
                  </DialogContentText>
                    <Typography style = {{color: '#f44336', fontSize: '13px', paddingTop: '8px'}}>
                      Caution: deleting this organization will cause the following:
                      <br/>
                      - All devices will be permanently deleted
                      <br/>
                      - All projects will be permanently deleted
                    </Typography>

                </DialogContent>
                <DialogActions style={{justifyContent:'flex-end'}}>
                  <Button onClick={this.handleClose} >
                    Close
                  </Button>
                  <Button  style={{color: '#cd3d64'}} type='submit' className={buttonClassname} disabled={loading} onClick={this.submitButtonClick}>
                    Delete { loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </DialogActions>
              </Paper>
         
        </Dialog>
        
      </Grid>
    );
  }
}

DeleteOrganizationModal.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapDispatchToProps = dispatch => ({
  showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
  showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),
  fetchSelectedOrganization: currentOrganization => dispatch(fetchSelectedOrganization(currentOrganization)),
  fetchOrganizations: () => dispatch(fetchOrganizations()),

})
const mapStateToProps = state => {
  return {
    selectedOrganization: state.organizations.selectedOrganization
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(DeleteOrganizationModal));
